module.exports = __webpack_public_path__ + "static/media/borte.f4c02dcc.m4a";